import { type JSX, Show } from "solid-js";
import { Icon } from "./Icon";
import "./Stat.css";
import { MaterialSymbol } from "./MaterialSymbol";
import { Text, type TextColor, type TextSize } from "./typography/Text";

/**
 * Display a statistic with an icon and value.
 *
 * [Design System →](http://localhost:5174/component/Stat)
 */
export const Stat = (props: {
	class?: string;
	/** @deprecated Use `symbol` instead. */
	icon?: JSX.Element;
	symbol?: string;
	value: JSX.Element;
	color?: TextColor;
	size?: TextSize;
}) => {
	return (
		<Text
			as="div"
			class={`gvtui-stats ${props.class ?? ""}`}
			color={props.color ?? "fg2"}
			size={props.size ?? "small"}
		>
			<Show when={props.icon && typeof props.icon === "string"}>
				<Icon icon={props.icon as string} />
			</Show>
			<Show when={props.icon && typeof props.icon !== "string"}>
				{props.icon}
			</Show>
			<Show when={props.symbol}>
				<MaterialSymbol symbol={props.symbol} />
			</Show>
			<span class="value">{props.value}</span>
		</Text>
	);
};
